import { render, staticRenderFns } from "./PayerClaimList.vue?vue&type=template&id=98b6dbc4&scoped=true&"
import script from "./PayerClaimList.vue?vue&type=script&lang=js&"
export * from "./PayerClaimList.vue?vue&type=script&lang=js&"
import style0 from "./PayerClaimList.vue?vue&type=style&index=0&id=98b6dbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6dbc4",
  null
  
)

export default component.exports